import {
    mergeSummaryKPI, mergeDonutKPI, mergeGraphKPI,
    isMergeElasticData, mergeLoad
} from '../interceptors/analyze';
import { getRangeId } from '../helpers/common';
import {
    GET_PLANNED_TODATE_REQUEST, GET_PLANNED_TODATE,
    ANALYZE_PARAMS, SET_SEARCH_PARAMS, GET_SUMMARY_REQUEST, GET_SUMMARY,
    GET_DONUT_REQUEST, GET_DONUT, GET_GRAPH_REQUEST, GET_GRAPH,
    GET_TRUCK_LOAD_REQUEST, GET_TRUCK_LOAD, GET_BALE_KPI_REQUEST, GET_BALE_KPI,
    GET_WORKED_KPI_REQUEST, GET_WORKED_KPI, GET_SPEED_REQUEST, GET_SPEED, SET_LOAD_INFO,
    PLAN_ANALYZE_INFO, CREW_ANALYZE_INFO, EG_ANALYZE_INFO, CLEAR_ANALYZE_DATA, SET_RETAIN_DATE_TOGGLE, TRAVEL_KPI, TRAVEL_KPI_REQUEST, ANALYZE_RECENT_SUMMARY, SET_LOAD_INFO_REQUEST,
    CUSTOMER_ANALYZE_INFO
} from '../constants/action-types';
import { VIEW_PLAN, VIEW_CREW, VIEW_EG, API_DATETIME_FORMAT, VIEW_CUSTOMER } from '../constants';
import { setSearchRangeParams } from '../helpers/session';
import moment from 'moment';

const initialState = {
    searchParams: {
        enable: true,
        rangeId: 0,
        range: null,
        customRange: null,
        custom: { from: null, to: null },
        absolute: { from: null, to: null },
        plannedTodate: {}
    },
    analyzeParams: {
        title: null,
        farmId: null,
        planTypeId: 4,
        crewId: null,
        customerId: null,
        crews: [],
        egId: null,
        view: null,
        isTruck: false,
        show: false,
        disabled: false,
        tab: 1,
        regionId: null,
        categeryId: null,
        shapeId: null,
    },
    donutInfo: {
        isRequesting: false,
        total_duration: { h: 24, m: 0 },
        planned_work: { h: 0, m: 0 },
        planned_utilization: { h: 0, m: 0 },
        actual_work: { h: 0, m: 0 },
        actual_utilization: { h: 0, m: 0 },
        total_duration_percentage: 100,
        planned_work_percentage: 0,
        planned_utilization_percentage: 0,
        actual_work_percentage: 0,
        actual_utilization_percentage: 0,
        utilization: 0,
        crew_count: 0,
        equipment_group_count: 0,
        work_in_progress: true,
        start_date: null,
        end_date: null
    },
    graphInfo: {
        isRequesting: false,
        planned: [],
        actual: [],
        trend: [],
        planned_activity: []
    },
    summaryInfo: {
        isRequesting: false,
        acres: { planned: 0, completed: 0, remaining: 0 },
        hours: { planned: { h: 0, m: 0 }, completed: { h: 0, m: 0 }, remaining: { h: 0, m: 0 } },
        crews: { planned: 0, active: 0, inactive: 0 },
        load: { total_loads: 0, avg_roundtrip_load_time: { h: 0, m: 0 } },
        region: { total: 0, completed: 0, remaining: 0, offload: [] },
        start_date: null,
        end_date: null
    },
    loadInfo: {
        isRequesting: false,
        crew: {
            avg_loads: 0,
            avg_speed: 0,
            avg_distance_per_load: 0,
            avg_load_time: {
                h: 0,
                m: 0
            }
        },
        vehicle: {
            loads: 0,
            avg_round_trip_load_time: {
                h: 0,
                m: 0
            },
            avg_distance_per_load: 0,
            avg_speed: null,
            max_speed: null
        }
    },
    bale: {
        isRequesting: false,
        payload: {
            avg_bale_time: {
                h: 0,
                m: 0
            },
            bales: 0
        }
    },
    elastic: {
        isRequesting: false,
        work: { data: null, deviceId: null, range: null },
        load: { data: null, deviceId: null, range: null }
    },
    speed: {
        isRequesting: false,
        payload: {
            is_speed: false,
            avg_speed: 0,
            max_speed: 0
        }
    },
    isToggleRetainDate: false,
    travelKpi: {
        isRequesting: false,
        data: {}
    },
    recentSummary: {
        replayBox: {
            data: {
                source_equipment_group_uuid: null,
                crew_uuid: null,
                target_equipment_group_uuid: null,
                load_activity_uuid: null,
                region_uuid: null,
                start_date: null,
                end_date: null
            },
            search_id: null
        },
        workWindow: {
            show: false,
            range: {
                start_date: null,
                end_date: null
            }
        }
    },
    loadCapacityInfo: {
        isRequesting: false,
        loadHistory: null,
        tareHistory: null
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_SEARCH_PARAMS: {
            const payload = action.payload ? action.payload : {};
            const { range, customRange, custom, absolute, timezone } = payload;
            setSearchRangeParams({ range, customRange, custom, ...absolute && { absolute } }, timezone);
            const rangeId = getRangeId(customRange, state.searchParams.rangeId);
            state = { ...state, searchParams: { ...state.searchParams, ...payload, rangeId } };
            break;
        }
        case SET_RETAIN_DATE_TOGGLE: {
            state = { ...state, isToggleRetainDate: true };
            break;
        }
        case GET_PLANNED_TODATE_REQUEST: {
            if (!action.rangeType || !action.id) return;
            state = {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    plannedTodate: {
                        ...state.searchParams.plannedTodate,
                        [action.id]: {
                            ...state.searchParams.plannedTodate[action.id],
                            isRequesting: true
                        }
                    }
                }
            };
            break;
        }
        case GET_PLANNED_TODATE: {
            const { rangeType, id, payload } = action;
            if (!rangeType || !id) return;

            state = {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    plannedTodate: {
                        ...state.searchParams.plannedTodate,
                        [action.id]: {
                            ...state.searchParams.plannedTodate[action.id],
                            isRequesting: false,
                            ...payload && {
                                [action.rangeType]: {
                                    from: payload.start_date ? moment.utc(payload.start_date).format(API_DATETIME_FORMAT) : null,
                                    to: payload.end_date ? moment.utc(payload.end_date).format(API_DATETIME_FORMAT) : null
                                }
                            }
                        }
                    }
                }
            };
            break;
        }
        case ANALYZE_PARAMS: {
            state = { ...state, analyzeParams: { ...state.analyzeParams, ...action.payload } };
            break;
        }
        case PLAN_ANALYZE_INFO:
            state = {
                ...state, analyzeParams: {
                    ...state.analyzeParams, view: VIEW_PLAN, title: action.payload.title,
                    ...action.payload.farmId ? { farmId: action.payload.farmId } : {},
                    ...action.payload.planTypeId ? { planTypeId: action.payload.planTypeId } : {},
                    crewId: null, egId: null, crews: [], isTruck: false, disabled: false,
                    regionId: null
                }
            };
            break;
        case CREW_ANALYZE_INFO:
            state = {
                ...state, analyzeParams: {
                    ...state.analyzeParams, view: VIEW_CREW, title: action.payload.title,
                    crewId: action.payload.crewId, crews: [], egId: null, isTruck: false, disabled: false,
                    regionId: null
                }
            };
            break;
        case CUSTOMER_ANALYZE_INFO:
            state = {
                ...state, analyzeParams: {
                    ...state.analyzeParams, view: VIEW_CUSTOMER, title: action.payload.title,
                    customerId: action.payload.customerId, crews: [], egId: null, isTruck: false, disabled: false,
                    regionId: null
                }
            };
            break;
        case EG_ANALYZE_INFO:
            state = {
                ...state, analyzeParams: {
                    ...state.analyzeParams, view: VIEW_EG,
                    title: action.payload.title,
                    crewId: action.payload.crewId,
                    crews: action.payload.crews,
                    egId: action.payload.egId,
                    isTruck: action.payload.isTruck, disabled: false,
                    categeryId: action.payload.categeryId
                }
            };
            break;
        case GET_SUMMARY_REQUEST:
            state = { ...state, summaryInfo: { ...initialState.summaryInfo, isRequesting: true } };
            break;
        case GET_SUMMARY:
            const { payload } = action;

            /*let summary = payload ? payload : initialState.summaryInfo;
           if (payload && isFarmView(view) && !payload.hasOwnProperty("load"))
               summary = { ...summary, load: { total_loads: 0 } };
           else if (payload && isCrewView(view) && !payload.hasOwnProperty("load"))
               summary = { ...summary, load: initialState.summaryInfo.load };
           else if (payload && isEGView(view) && !payload.hasOwnProperty("load"))
               summary = { ...summary, load: initialState.summaryInfo.load }; */

            state = { ...state, summaryInfo: { ...initialState.summaryInfo, ...payload, isRequesting: false } };

            if (isMergeElasticData(state, "work")) state = { ...state, ...mergeSummaryKPI(state, state.elastic.work, initialState) };
            if (isMergeElasticData(state, "load")) state = { ...state, ...mergeLoad(state, state.elastic.load) };
            break;
        case GET_DONUT_REQUEST:
            state = { ...state, donutInfo: { ...initialState.donutInfo, isRequesting: true } };
            break;
        case GET_DONUT: {
            const payload = action.payload ? action.payload : initialState.donutInfo;
            state = { ...state, donutInfo: { ...payload, isRequesting: false } };
            if (isMergeElasticData(state, "work")) state = { ...state, ...mergeDonutKPI(state, state.elastic.work) };
            break;
        }
        case GET_GRAPH_REQUEST:
            state = { ...state, graphInfo: { ...initialState.graphInfo, isRequesting: true } };
            break;
        case GET_GRAPH: {
            const payload = action.payload ? action.payload : initialState.graphInfo;
            state = { ...state, graphInfo: { ...payload, isRequesting: false } };
            if (isMergeElasticData(state, "work")) state = { ...state, ...mergeGraphKPI(state, state.elastic.work, initialState, action.timezone) };
            break;
        }
        case GET_TRUCK_LOAD_REQUEST:
            state = { ...state, loadInfo: { ...initialState.loadInfo, isRequesting: true } };
            break;
        case GET_TRUCK_LOAD: {
            const { payload } = action;
            state = { ...state, loadInfo: { ...initialState.loadInfo, ...payload, isRequesting: false } };
            if (isMergeElasticData(state, "load")) state = { ...state, ...mergeLoad(state, state.elastic.load) };
            break;
        }
        case GET_BALE_KPI_REQUEST: {
            state = { ...state, bale: { ...initialState.bale, isRequesting: true } };
            break;
        }
        case GET_BALE_KPI: {
            const payload = action.payload ? action.payload : {};
            state = { ...state, bale: { ...initialState.bale, payload: { ...initialState.bale.payload, ...payload } } };
            break;
        }
        case GET_WORKED_KPI_REQUEST:
            state = { ...state, elastic: { ...initialState.elastic, isRequesting: true } };
            break;
        case GET_WORKED_KPI: {
            const payload = action.payload ? action.payload : {};
            state = { ...state, elastic: { ...state.elastic, ...payload, isRequesting: false } };

            if (payload.work && payload.work.data && isMergeElasticData(state, "work")) {
                state = { ...state, ...mergeSummaryKPI(state, state.elastic.work, initialState) };
                state = { ...state, ...mergeDonutKPI(state, state.elastic.work) };
                state = { ...state, ...mergeGraphKPI(state, state.elastic.work, initialState, action.timezone) };
            }

            if (payload.load && payload.load.data && isMergeElasticData(state, "load"))
                state = { ...state, ...mergeLoad(state, state.elastic.load) };

            break;
        }
        case GET_SPEED_REQUEST:
            state = {
                ...state, speed: {
                    ...initialState.speed, isRequesting: true,
                    payload: { ...initialState.speed.payload, is_speed: true }
                }
            };
            break;
        case GET_SPEED: {
            const payload = action.payload ? { ...action.payload, is_speed: true } : {};
            state = { ...state, speed: { ...initialState.speed, payload: { ...initialState.speed.payload, ...payload } } };
            break;
        }
        case CLEAR_ANALYZE_DATA:
            state = {
                ...state,
                elastic: initialState.elastic,
                summaryInfo: initialState.summaryInfo,
                donutInfo: initialState.donutInfo,
                graphInfo: initialState.graphInfo,
                loadInfo: initialState.loadInfo,
                bale: initialState.bale
            };
            break;
        case TRAVEL_KPI_REQUEST:
            state = {
                ...state, travelKpi: {
                    ...state.travelKpi, isRequesting: true
                }
            };
            break;
        case TRAVEL_KPI:
            const currentEg = Object.keys(action.payload).map(e => e);
            state = {
                ...state, travelKpi: {
                    ...state.travelKpi,
                    isRequesting: false,
                    data: {
                        ...state.travelKpi.data,
                        [currentEg[0]]: action.payload[currentEg[0]] && action.payload[currentEg[0]].distance
                            ? action.payload[currentEg[0]].distance : 0
                    }
                }
            };
            break;
        case SET_LOAD_INFO_REQUEST: {
            state = {
                ...state, loadCapacityInfo: {
                    isRequesting: true,
                    loadHistory: null,
                    tareHistory: null,
                }
            };

            break;
        }
        case SET_LOAD_INFO: {
            const payload = action.payload ? action.payload : {};

            if (action.loadType === 'load') {
                state = {
                    ...state, loadCapacityInfo: {
                        ...state.loadCapacityInfo, loadHistory: payload
                    }
                };
            }
            else {
                state = {
                    ...state, loadCapacityInfo: {
                        ...state.loadCapacityInfo, tareHistory: payload, isRequesting: false
                    }
                };
            }
            break;
        }
        case ANALYZE_RECENT_SUMMARY: {
            state = {
                ...state, recentSummary: {
                    ...state.recentSummary, ...action.payload.replayBox ? {
                        replayBox: { ...action.payload.replayBox }
                    } : {
                        replayBox: initialState.recentSummary.replayBox
                    }, ...action.payload.workWindow ? {
                        workWindow: { ...action.payload.workWindow }
                    } : {
                        workWindow: initialState.recentSummary.workWindow
                    }
                }
            };
            break;
        }
        default:
            break;
    }
    return state;
};